import { createAction, props } from '@ngrx/store';

import { SubscriptionsParams } from '../modules/subscriptions/subscriptions.interface';
import { AnalysesParams } from '../modules/analyses/analyses.interface';
import { QuestionsParams } from '../modules/questions/questions.interface';
import { UsersParams } from '../modules/users/users.interface';
import { CompaniesParams } from '../modules/companies/companies.interface';
import { PitchesParams } from '../modules/pitches/pitches.interface';
import { InvestmentCompaniesParams } from '../modules/investment-companies/investment-companies.interface';
import { InvestmentsParams } from '../modules/investments/investments.interface';
import { AppViews } from '../shared/helpers/enums';
import { Params } from '../core/interfaces/shared.interface';

export type AppParams =
  | SubscriptionsParams
  | AnalysesParams
  | CompaniesParams
  | InvestmentCompaniesParams
  | InvestmentsParams
  | PitchesParams
  | QuestionsParams
  | UsersParams
  | Params;

export const filterResults = createAction('[App] Filter Results', props<{ params: AppParams; appView: AppViews }>());

export type FilterResultsUnion = ReturnType<typeof filterResults>;
